var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-info3';
                    var viewUrl = 'sprite.svg#view-icon-info3';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 480 480',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };